//@flow
import {useSelector} from 'react-redux';

import {actions as ManualOrderActions} from '../duck';
import {useActions} from '../../../utils/globalStore';
import type {RootState} from '../..';

const manualOrderSelector = (state: RootState) => ({
  products: state.manualOrder.products,
  paginationProducts: state.manualOrder.pagination,
  isFetchingProducts: state.manualOrder.isFetchingProducts,
});

export function useManualOrder() {
  return useSelector(manualOrderSelector);
}

const manualOrderActions = {
  resetProductsFilter: ManualOrderActions.resetProductsFilter,
  fetchProducts: ManualOrderActions.fetchProducts,
};

export function useManualOrderActions() {
  const actions = useActions(manualOrderActions);
  return actions;
}

const productItemsSelector = (state: RootState) =>
  state.manualOrder.shoppingCart ? state.manualOrder.shoppingCart.items : [];

export function useProductOutOfStock(productId: string) {
  const productItems = useSelector(productItemsSelector);

  const validateStock = () => {
    const productItem = productItems.find(
      productItem => productItem.product.id === productId
    );

    if (!productItem || !productItem.product.stockSetting) return false;

    return productItem.amount === productItem.product.stockSetting.stock;
  };

  const isOutOfStock = validateStock();

  return isOutOfStock;
}

// SHIPPING & PICKUP
const shippingMethodSelector = (state: RootState) =>
  state.logisticsConfig.shippingMethod;
const pickupMethodSelector = (state: RootState) =>
  state.logisticsConfig.pickupMethod;

export function useShippingMethodConfig() {
  const shippingMethod = useSelector(shippingMethodSelector);
  const pickupMethod = useSelector(pickupMethodSelector);

  return {
    shippingMethod,
    pickupMethod,
  };
}

const currencySelector = (state: RootState) => state.currency.currency;

export const useGetCurrency = () => {
  return useSelector(currencySelector);
};
